import { RouteProps } from 'react-router-dom';
import { dashboardPagesMenu } from '../menu';
import PastasHeader from '../pages/_layout/_headers/PastasHeader';
// eslint-disable-next-line import/no-unresolved, import/extensions
import DashboardPastasHeader from '../pages/_layout/_headers/DashboardPastasHeader';
import DefaultHeader from '../pages/_layout/_headers/DefaultHeader';

const headers: RouteProps[] = [
	{ path: dashboardPagesMenu.dashboard.path, element: <PastasHeader /> },
	{ path: dashboardPagesMenu.dashboardPastas.path, element: <DashboardPastasHeader /> },
	{
		path: `*`,
		element: <DefaultHeader />,
	},
];

export default headers;
